import type { HelpFile } from '../../types/help'
import { MyDashboardTestIds } from '../../../testids/MyDashboardTestIds'

export const myDashboardHelp: HelpFile = {
  docPage: '/docs/my-iam/my-access',
  texts: {
    [MyDashboardTestIds.myDashboardPage]:
      'Personal IAM workspace — summary of active Access Profile assignments, pending requests, and open approvals.',
    [MyDashboardTestIds.cardTitleMyAccess]:
      'Summary of currently active Access Profile assignments.',
    [MyDashboardTestIds.cardTitleMyRequests]:
      'Pending access requests submitted on this identity\'s behalf.',
    [MyDashboardTestIds.cardTitleMyApprovals]:
      'Access requests waiting for an approval decision.',
    [MyDashboardTestIds.linkMyAccess]: null,
    [MyDashboardTestIds.linkMyRequests]: null,
    [MyDashboardTestIds.linkMyApprovals]: null,
    [MyDashboardTestIds.approvalsCount]:
      'Number of access requests currently pending approval.',
    [MyDashboardTestIds.myAccessCount]:
      'Total number of access entitlements granted to you.',
    [MyDashboardTestIds.pendingRequestsCount]:
      'Number of access requests waiting for your approval.',
  },
}
